import KReactive from './core/utils/KReactive'
import KTheme from './core/KTheme'
import KDevice from './core/utils/KDevice'
import KServer from './core/KServer'
import { document } from 'ssr-window'

const init = () => {
  const kamala = new KReactive({
    ripple: true,
    theming: {},
    // locale: {
    //   startYear: 1900,
    //   endYear: 2099,
    //   dateFormat: 'YYYY-MM-DD',
    //   days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    //   shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    //   shorterDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    //   months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    //   shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    //   shorterMonths: ['J', 'F', 'M', 'A', 'M', 'Ju', 'Ju', 'A', 'Se', 'O', 'N', 'D'],
    //   firstDayOfAWeek: 0
    // }
  })

  Object.defineProperties(kamala.theming, {
    metaColors: {
      get: () => KTheme.metaColors,
      set(metaColors) {
        KTheme.metaColors = metaColors
      },
    },
    theme: {
      get: () => KTheme.theme,
      set(theme) {
        KTheme.theme = theme
      },
    },
    enabled: {
      get: () => KTheme.enabled,
      set(enabled) {
        KTheme.enabled = enabled
      },
    },
  })

  if (parseInt(KDevice.pixelRatio) > 1) {
    document.querySelector('html').classList.add('is-retina')
  }

  if (!KServer) {
    window.addEventListener('unhandledrejection', function (event) {
      // MessageBox组件:未处理promise reject错误时的异常处理
      if (event.reason && event.reason.trigger === 'kamalaMessage') {
        event.preventDefault()
      }
    })
  }

  return kamala
}

export default (Vue) => {
  if (!Vue.kamala) {
    Vue.kamala = init()
    Vue.prototype.$kamala = Vue.kamala
  }
}
